import React from 'react';

import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';

export interface PageDataBoundaryProps {
  /** true: 本文を描画してよい。false: スピナーを返す */
  ready: boolean;
  /** ローディングメッセージ（デフォルト '読み込み中...'） */
  message?: string;
  /**
   * 全画面でスピナーを表示するか。デフォルト true。
   * フォーム内など部分領域だけ覆いたい場合のみ false にする。
   */
  fullPage?: boolean;
  children: React.ReactNode;
}

/**
 * ページデータ境界。
 *
 * 役割:
 * - 各ページが必要とする全データが揃うまで子要素を描画させない（部分描画によるチラつきを防止）。
 * - AppReadyGate と同一の LoadingSpinner DOM を返すため、ゲート→ページ境界→本文の遷移で
 *   Spinner アニメーションが途切れない。
 */
export const PageDataBoundary: React.FC<PageDataBoundaryProps> = ({
  ready,
  message = '読み込み中...',
  fullPage = true,
  children,
}) => {
  if (!ready) return <LoadingSpinner fullPage={fullPage} message={message} />;
  return <>{children}</>;
};

export default PageDataBoundary;
